export const environment = {
  production: true,
  baseUrl: 'https://backend.24vahingot.fi/',
  imageUrl: 'https://test.24vahingot.fi/',
  containerName: '24vahingot-dev',
};
